<template>
  <div class="brandList">
    <BrandForm ref="form" @success="getList"/>
    <FilterForm :fields="searchFields" @submit="search"/>
    <BasicTable
    border
    hasOperate
    customClass="table"
    :tableData="tableData"
    :treeProps="{ children: 'sub', hasChildren: 'hasChildren' }"
    :columns="columns"
    :pageSize="+pageOption.per_page"
    :currentPage="+pageOption.current_page"
    :total="+pageOption.total"
    :loading="loading"
    @pageChange="pageChange">
    <template slot="tableOpeate">
      品牌列表&emsp;
      <AppButton size="small" type="primary" plain @click="addbrand"><i class="fa fa-plus fa-lg icon"></i>新增</AppButton>&emsp;
    </template>
    <template v-slot:is_hot="{ item }">
      <CheckBox :value="!!item.is_hot" :asyncClick="changeStatus(item, 'hot')"/>
    </template>
    <template v-slot:is_show="{ item }">
      <CheckBox :value="!!item.is_show" :asyncClick="changeStatus(item, 'show')"/>
    </template>
    <template v-slot:operate="{ item }">
      <AppButton size="small" type="primary" plain @click="editBrand(item)">编辑</AppButton>
      <AppButton type="primary" plain size="small" @click="deleteItem(item)"><i class="fa fa-trash-o fa-lg icon"></i>删除</AppButton>
    </template>
    <template v-slot:brand_logo="{ item }">
        <el-image
      style="height: 40px; width: 50px"
      :src="item.brand_logo"
      fit="fill"></el-image>
    </template>
    </BasicTable>
  </div>
</template>

<script>
import { GoodsService } from '../../service/goods.service'
import { BrandService } from '../../service/brand.service'
import BrandForm from './formBrandList.vue';
import { MessageBox } from 'element-ui';
const searchFields = [
  { name: '品牌名称', key: 'brand_name', type: 'input' },
];
const columns = [
  { name: '品牌名称', key: 'brand_name' },
  { name: '品牌LOGO', key: 'brand_logo', type: 'custom' },
  { name: '品牌描述', key: 'brand_desc' },
  { name: '品牌网址', key: 'site_url' },
  { name: '是否热门', key: 'is_hot', type: 'custom' },
  { name: '是否展示', key: 'is_show', type: 'custom' },
  { name: '操作', key: 'operate', type: 'custom' },
];
  export default {
    name: 'brandList',
    components: { BrandForm },
    data() {
      return {
        searchFields,
        searchValues: {},
        tableData: [],
        columns,
        loading: false,
        pageOption: {
          total: 0,
          current_page: 1,
          per_page: 20,
        }
      }
    },
    created() {
      this.getList();
    },
    methods: {
      addbrand() {
        this.$refs.form.open('add')
      },
      editBrand(data) {
        this.$refs.form.open('edit', data);
      },
      deleteItem(data) {
        MessageBox.confirm('确定要删除这条这个品牌吗？', '删除品牌').then(async () => {
          await BrandService.delete(data.id);
          this.getList();
        });
      },
      search(data) {
        this.searchValues = data;
        this.getList();
      },
      async getList() {
        this.loading = true;
        const data = await GoodsService.brandList({ rows: this.pageOption.per_page, page: this.pageOption.current_page, ...this.searchValues });
        data.data.forEach(item => {
          item.brand_logo = GoodsService.spliceImg(item.brand_logo);
        });
        this.loading = false;
        this.tableData = data.data;
        this.pageOption = data;
      },
      changeStatus(item, type) {
        return async () => {
          await GoodsService.brandChangeStatus(item.id, type, item['is_'+ type] === 1 ? 0 : 1);
          await this.getList();
        }
      },
      pageChange(index) {
        this.pageOption.current_page = index;
        this.getList();
      },
    }
  }
</script>

<style lang="scss" scoped>

</style>